/** « Start for free » (D-142, action 4): what the free trial opens, said clearly, with no card
 * and no payment: a discovery mini mock, the first unit of each course, the placement test. The
 * complete free mock has its own card (D-172, `FreeMockCard`). Every value is the trial data of
 * the account. */

import { useAcademyAccountRetrieve } from "@agencyos/api-client";
import { Gift } from "lucide-react";
import { useTranslation } from "react-i18next";

import "../coaching/coaching.css";

interface TrialData {
  first_unit?: boolean;
  discovery_enabled?: boolean;
  placement?: boolean;
}

export function FreeStart() {
  const { t } = useTranslation();
  const account = useAcademyAccountRetrieve({ query: { retry: false, staleTime: 60_000 } });
  const data = account.data?.status === 200 ? account.data.data : undefined;
  if (!data || data.active_until) return null;
  const trial = (data.trial ?? {}) as TrialData;
  if (!trial.first_unit && !trial.discovery_enabled) return null;
  return (
    <section className="ac-surface ac-card co-free" aria-labelledby="co-free-title" data-testid="free-start">
      <h2 id="co-free-title" className="ac-title-3">
        <Gift aria-hidden size={16} /> {t("coaching.free.title")} · <span className="ac-footnote">{t("coaching.free.subtitle")}</span>
      </h2>
      <ul>
        {trial.discovery_enabled ? <li>{t("coaching.free.discovery")}</li> : null}
        {trial.first_unit ? <li>{t("coaching.free.unit")}</li> : null}
        {trial.placement ? <li>{t("coaching.free.placement")}</li> : null}
      </ul>
    </section>
  );
}
